import { render } from "./ExportComp.vue?vue&type=template&id=56eb37ad&scoped=true"
import script from "./ExportComp.vue?vue&type=script&lang=js"
export * from "./ExportComp.vue?vue&type=script&lang=js"

import "./ExportComp.vue?vue&type=style&index=0&id=56eb37ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56eb37ad"]])

export default __exports__